import { dispatcher, api, RESOURCE_FETCH } from 'react-structure-admin';

export const PATIENT_PACKAGE = 'PATIENT_PACKAGE';
export const PATIENT_PACKAGE_SHOW_LIST = 'PATIENT_PACKAGE_SHOW_LIST';
export const PATIENT_PACKAGE_CLOSE_LIST = 'PATIENT_PACKAGE_CLOSE_LIST';

export const PATIENT_PACKAGE_INACTIVATE = 'PATIENT_PACKAGE_INACTIVATE';
export const PATIENT_PACKAGE_INACTIVATE_FINISHED =
  'PATIENT_PACKAGE_INACTIVATE_FINISHED';

export const showList = (currentPatient) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      PATIENT_PACKAGE_SHOW_LIST,
      'patientPackages',
      currentPatient
    )
  );
};

export const closeList = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(PATIENT_PACKAGE_CLOSE_LIST, 'patientPackages')
  );
};

export const inactivateItem = (packageItemId, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patientPackages',
    actionType: PATIENT_PACKAGE_INACTIVATE,
    effect: async () =>
      api.put(`patients/package-items/${packageItemId}/inactivate`, {}),
    onSuccess
  });
};

export const activateItem = (packageItemId, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patientPackages',
    actionType: PATIENT_PACKAGE_INACTIVATE,
    effect: async () =>
      api.put(`patients/package-items/${packageItemId}/activate`, {}),
    onSuccess
  });
};

export const fetch = (_, params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patientPackages',
    actionType: RESOURCE_FETCH,
    effect: async () => api.fetch('patients/package-items', params)
  });
};
